<template>
  <div
    class="login-box show-flex-box-r show-flex-center"
    @click.self="colseLoginWin()"
    v-show="isShowLogin"
  >
    <div
      class="login-total show-flex-box-r show-flex-center"
      v-if="isShowLogin && !isShowThirdLogin && !isShowUserAgreement"
    >
      <div class="login-all show-flex-box-c">
        <!-- X图标 -->
        <em @click.self="colseLoginWin()"></em>
        <dl class="login-content show-flex-box-c">
          <dt class="select-login-way show-flex-box-r">
            <span :class="activeClass == 1? 'active': '' " @click="selectLoginWay(1)">账号密码登录</span>
            <span :class="activeClass == 2? 'active': '' " @click="selectLoginWay(2)">短信快捷登录</span>
            <span :class="activeClass == 3? 'thirdActive': '' " @click="selectLoginWay(3)">邮箱快捷登录</span>
          </dt>

          <dd class="login-input-number show-flex-box-c">
            <h3 class="show-flex-box-c">
              <strong>{{accountChange}}</strong>
              <span class="show-flex-box-r">
                <input type="text" :placeholder="firstplaceholder" v-model="loginForm.account" />
                <strong></strong>
                <em
                  v-if="showVerifyCode && countDownStatus"
                  style="color:rgba(193,190,190,1);"
                >{{remainCount}} s</em>
                <em v-if="showVerifyCode && !countDownStatus" @click="verifyCodeCountDown()">获取验证码</em>
                <!-- <em v-if="showCode && countDown" style="color:rgba(193,190,190,1);">
                  {{remainCount}} s
                </em>
                <em v-if="showCode && !countDown" @click="!countDown && verifyCodeCountDown()">
                  获取验证码
                </em>-->
              </span>
              <em>
                <em v-if="validAccountRes">{{validAccountResTitle}}</em>
              </em>
            </h3>
            <h3 class="show-flex-box-c">
              <strong>{{passWordOrCode}}</strong>
              <span class="show-flex-box-r">
                <input
                  :type="checkPasswordType()"
                  :placeholder="secondplaceholder"
                  v-model="loginForm.password"
                />
              </span>
              <em>
                <em v-if="validPasswordRes">{{validPasswordResTitle}}</em>
              </em>
            </h3>
            <h4 class="show-flex-box-r">
              <span @click="goToregister()">点击注册</span>
              <span v-if="showForgetpassword" @click="findPassword()">忘记密码？</span>
            </h4>
            <div class="show-flex-box-r" @click="clickToLogin()">
              <span>登录</span>
            </div>
          </dd>
          <dd class="login-footter show-flex-box-r">
            <div class="select-login-icon show-flex-box-r">
              <span>第三方登录</span>
              <ul class="select-login-icon-list show-flex-box-r">
                <li
                  class="select-login-icon-item show-flex-bor-r"
                  v-for="(item,index) in loginIconList"
                  :key="index"
                  @click="openThirdLoginPage(item,index)"
                >
                  <img :src="item.icon_img" alt />
                </li>
              </ul>
            </div>
            <h3 class="agree-login show-flex-box-r">
              <span :class="selectActive == true? 'select-active':''" @click="agreeSelectLogin()"></span>
              <strong>
                登录注册即同意
                <em @click="openUserAgreementPop()">用户协议</em>
              </strong>
            </h3>
          </dd>
        </dl>
      </div>
    </div>
    <div class="third-login" v-show="isShowThirdLogin">
      <thirdLogin
        ref="colse_third_login"
        :curThirdLoginType="curThirdLoginType"
        @close-third-login-pop="closeThirdLoginPop"
      ></thirdLogin>
    </div>
    <div class="user-agreement show-flex-box-c" v-if="isShowUserAgreement">
      <em @click="closeUserAgreementPop()"></em>
      <div class="show-flex-box-c">
        <span>用户协议</span>
        <div class="box-scrollbar-hidden" v-html="userAgreement"></div>
      </div>
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import regex from "@/filter/regex";
// import {LoginUser} from "@/model/login_user.js";
import thirdLogin from "@/views/login/third_login";
import { CountDown } from "@/../static/js/CountDown";

export default {
  name: "login",
  data() {
    return {
      loginIconList: [
        {
          type: "weixin",
          icon_img: require("../../assets/login/wechat_icon.png")
        },
        {
          type: "weibo",
          icon_img: require("../../assets/login/weibo_icon.png")
        },
        { type: "qq", icon_img: require("../../assets/login/qq_icon.png") }
      ],
      activeClass: 1,
      selectActive: false,
      showCode: false,
      accountChange: "账号",
      firstplaceholder: "请输入手机号",
      passWordOrCode: "密码",
      secondplaceholder: "请输入密码",
      showForgetpassword: true,
      validAccountRes: false,
      validPasswordRes: false,
      validAccountResTitle: "",
      validPasswordResTitle: "",
      isShowLogin: false,
      isShowThirdLogin: false,
      isShowUserAgreement: false,
      userAgreement: "",
      loginLoading: false,
      showVerifyCode: false,
      loginForm: {
        type: "password",
        account: "",
        password: ""
      },
      counter: null,
      countDownStatus: false,
      remainCount: 60,
      curThirdLoginType: ""
    };
  },
  components: {
    thirdLogin
  },
  computed: {
    listenToken: function() {
      return this.$store.state.token;
    }
  },
  mounted() {
    this.listenKeyEvent();
    // this.initCountDown();
    this.getUserAgreement();
    this.checkIsWXCallback();
  },
  methods: {
    getUserAgreement: function() {
      var params = {
        code: "platform_agreement"
      };

      this.$client
        .getDocumentDetail(params)
        .then(res => {
          this.userAgreement = res.data.content;
        })
        .catch(err => {
          this.$message({
            showClose: true,
            message: err.data.message,
            type: "error"
          });
        });
    },
    initCountDown: function() {
      var _this = this;

      this.counter = new CountDown(60, function(cnt) {
        if (0 === cnt) {
          _this.clearCounterWithCount();
        } else {
          _this.remainCount = cnt;
        }
      });
    },
    clearCounterWithCount: function() {
      this.counter && this.counter.cancel();
      this.countDownStatus = false;
    },
    checkIsWXCallback: function() {
      var WxCertificate = this.$route.query.loginType || false;

      if (WxCertificate == "WX") {
        this.isShowLogin = true;
        this.isShowThirdLogin = true;
        // this.checkWxLoginCode(WxCertificate);
      }
    },
    checkWxLoginCode: function(wxCode) {
      var params = {
        code: wxCode
      };
      return;
      this.$client
        .wxLogin(params)
        .then(res => {
          var code = res.status + "";
          if (code == "200") {
            var callBackData = res.data;
            this.loginSucceed(callBackData);
          }
        })
        .catch(err => {});
    },
    verifyCodeCountDown: function(count) {
      var allowSendStatus = this.checkCanVerify();

      if (!this.counter) {
        this.initCountDown();
      }
      
      if (allowSendStatus) {
        this.sendMessage();
      }
    },
    checkCanVerify: function() {
      var status = true;
      if (this.activeClass == 2) {
        if (regex.isEmpty(this.loginForm.account)) {
          this.validAccountRes = true;
          this.validAccountResTitle = "请输入您的手机号";
          return false;
        } else {
          this.validAccountRes = false;
          this.validAccountResTitle = "";
        }

        if (regex.isPhoneNumber(this.loginForm.account)) {
          this.validAccountRes = false;
          this.validAccountResTitle = "";
          return true;
        } else {
          this.validAccountRes = true;
          this.validAccountResTitle = "您输入的手机号格式不正确";
          return false;
        }
      } else if (this.activeClass == 3) {
        if (regex.isEmpty(this.loginForm.account)) {
          this.validAccountRes = true;
          this.validAccountResTitle = "请输入您的邮箱";
          return false;
        } else {
          this.validAccountRes = false;
          this.validAccountResTitle = "";
        }

        if (regex.isEmail(this.loginForm.account)) {
          this.validAccountRes = false;
          this.validAccountResTitle = "";
          return true;
        } else {
          this.validAccountRes = true;
          this.validAccountResTitle = "您输入的邮箱格式不正确";
          return false;
        }
      }

      return status;
    },
    // 发送验证码
    sendMessage: function() {
      var _this = this;
      var params = {
        account: this.loginForm.account,
        way: this.activeClass == 2 ? "phone" : "email",
        type: "login"
      };

      this.$client
        .sendVerifyCode(params)
        .then(res => {
          _this.countDownStatus = true;
          _this.counter.start();
        })
        .catch(err => {
          _this.clearCounterWithCount();

          if (err.data && err.data.message) {
            this.$message({
              showClose: true,
              message: err.data.message,
              type: "error"
            });
          }
        });
    },
    clickToLogin: function() {
      if (this.validLoginParams()) {
        if (!this.selectActive) {
          this.$message({
            showClose: true,
            message: "您还没有同意用户协议",
            type: "error"
          });
          return;
        }
        if (!this.loginLoading) {
          this.loginLoading = true;
          var params = {
            type: this.loginForm.type,
            account: this.loginForm.account,
            password: this.loginForm.password
          };

          this.$client
            .userLogin(params)
            .then(res => {
              if (res.code == 200) {
                var userToken = res.data.token;
                var userInfo = res.data.user;
                this.loginSucceed(userToken);
                this.resetForm();
                this.loginLoading = false;
              }
            })
            .catch(err => {
              if (err.data && err.data.message) {
                this.$message({
                  showClose: true,
                  message: err.data.message,
                  type: "error"
                });
              }
              this.loginLoading = false;
            });
        }
      }
    },
    validLoginParams: function() {
      var status = true;
      if (regex.isEmpty(this.loginForm.account)) {
        this.validAccountRes = true;
        this.validAccountResTitle =
          this.activeClass == 1
            ? "请输入您的账号"
            : this.activeClass == 2
            ? "请输入您的手机号"
            : "请输入您的邮箱";
        status = false;
      } else {
        this.validAccountRes = false;
        this.validAccountResTitle = "";
      }
      if (regex.isEmpty(this.loginForm.password)) {
        this.validPasswordRes = true;
        this.validPasswordResTitle =
          this.activeClass == 1 ? "请输入您的密码" : "请输入您收到的的验证码";
        status = false;
      } else {
        this.validPasswordRes = false;
        this.validPasswordResTitle = "";
      }

      return status;
    },
    loginSucceed: function(token) {
      let saveTokenObj = {
        token: token
      };
      this.$store.commit("SET_TOKEN", saveTokenObj);
      this.$store.commit("LOGIN", true); //登录成功后改变登录状态
      this.isShowLogin = false;
    },
    listenKeyEvent() {
      let _this = this;
      $(document).keyup(function(event) {
        if (event.keyCode == 13) {
          if (_this.isShowLogin && !_this.loginLoading) {
            _this.clickToLogin();
          }
        }
      });
    },
    colseLoginWin: function() {
      this.isShowLogin = !this.isShowLogin;
      this.isShowThirdLogin = false;
      this.isShowUserAgreement = false;
      // this.$router.push({path: '/home'});
    },
    openUserAgreementPop: function() {
      this.isShowUserAgreement = true;
    },
    closeUserAgreementPop: function() {
      this.isShowUserAgreement = false;
    },
    selectLoginWay: function(index) {
      this.activeClass = index;
      this.validPasswordRes = false;
      this.validAccountRes = false;
      this.validAccountResTitle = "";
      this.validPasswordResTitle = "";
      this.showVerifyCode = index != 1;
      this.clearCounterWithCount();

      if (index == 1) {
        this.accountChange = "账号";
        this.firstplaceholder = "请输入手机号/邮箱";
        this.showCode = false;
        this.passWordOrCode = "密码";
        this.secondplaceholder = "请输入密码";
        this.showForgetpassword = true;
        this.loginForm.type = "password";
      } else if (index == 2) {
        this.accountChange = "手机号";
        this.firstplaceholder = "请输入手机号";
        this.showCode = true;
        this.passWordOrCode = "验证码";
        this.secondplaceholder = "请输入验证码";
        this.showForgetpassword = false;
        this.loginForm.type = "verify_code";
      } else {
        this.accountChange = "邮箱";
        this.firstplaceholder = "请输入邮箱";
        this.showCode = true;
        this.passWordOrCode = "验证码";
        this.secondplaceholder = "请输入验证码";
        this.showForgetpassword = false;
        this.loginForm.type = "verify_code";
      }
    },
    agreeSelectLogin: function() {
      this.selectActive = !this.selectActive;
      // this.$refs.colse_third_login.backLoginPage();
    },
    openThirdLoginPage: function(item, index) {
      switch (item.type) {
        case "weixin":
          this.curThirdLoginType = "weixin";
          this.isShowThirdLogin = true;
          break;
        case "qq":
          this.curThirdLoginType = "qq";
          QC.Login.showPopup({
            appId: "101867658",
            redirectURI: "https://zgsfxg.com/web/index?loginType='QQ'"
          });
          // this.isShowThirdLogin = true;
          break;
        default:
          break;
      }
    },
    closeThirdLoginPop: function() {
      this.isShowThirdLogin = false;
    },
    toCloseLoginPop: function() {
      this.isShowLogin = false;
    },
    findPassword: function() {
      this.$parent.$refs.findPassword.closeFindPasswordPop();
    },
    goToregister: function() {
      this.$parent.$refs.register.closeRegisterPop();
    },
    checkPasswordType: function() {
      var type = "";
      switch (this.activeClass) {
        case 1:
          type = "password";
          break;
        case 2:
          type = "text";
          break;
        case 3:
          type = "text";
          break;
        default:
          break;
      }

      return type;
    },
    resetForm: function() {
      this.loginForm.account = "";
      this.loginForm.password = "";
    },
    resetFormValid: function() {
      this.validAccountRes = false;
      this.validPasswordRes = false;
      this.validAccountResTitle = "";
      this.validPasswordResTitle = "";
    },
    setLoginPopShowStatus: function() {
      if (!this.isShowLogin) {
        this.$store.dispatch("setLoginPopShowStatus",false);
      }
    }
  },
  watch: {
    listenToken: function() {
      if (!this.listenToken) {
        this.isShowLogin = true;
      }
    },
    activeClass: function() {
      this.resetForm();
    },
    isShowLogin: function() {
      this.resetForm();
      this.resetFormValid();
      this.selectActive = false;
      this.setLoginPopShowStatus();
    }
  }
};
</script>
<style lang="less" scoped>
.login-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background: rgba(0, 0, 0, 0.3);
  .login-total {
    position: absolute;
    width: 553px;
    height: 553px;
    background: rgba(255, 255, 255, 1);
    border-radius: 2px;
    z-index: 1000;
    .login-all {
      width: 513px;
      height: 513px;
      align-items: flex-end;
      > em {
        width: 22px;
        height: 22px;
        cursor: pointer;
        transition: all 0.2s ease;
        background: url("../../assets/login/close_arrow_icon.png") center center no-repeat;
        background-size: 22px 22px;
      }
      > em:hover {
        transform: scale(1.2);
      }
      .login-content {
        padding: 8px 60px 32px 60px;
        .select-login-way {
          width: 100%;
          height: 50px;
          align-items: center;
          > span {
            width: 129px;
            height: 50px;
            font-size: 15px;
            font-family: SourceHanSerifCN-SemiBold, SourceHanSerifCN;
            font-weight: 600;
            color: rgba(48, 41, 41, 1);
            line-height: 50px;
            text-align: center;
            border-bottom: 1px #eeeeee solid;
            cursor: pointer;
          }
          .active {
            color: rgba(230, 0, 18, 1);
            border-top: 2px #e60012 solid;
            border-left: 1px #eeeeee solid;
            border-right: 1px #eeeeee solid;
            border-bottom: none;
          }
          .thirdActive {
            color: rgba(230, 0, 18, 1);
            border-top: 2px #e60012 solid;
            border-left: 1px #eeeeee solid;
            border-right: 1px #ffffff solid;
            border-bottom: none;
          }
        }
        .login-input-number {
          width: 100%;
          margin: 45px 0px 32px 0px;
          > h3 {
            width: 100%;
            // margin-bottom: 20px;
            > strong {
              height: 21px;
              font-size: 15px;
              font-family: SourceHanSerifCN-SemiBold, SourceHanSerifCN;
              font-weight: 600;
              color: rgba(48, 41, 41, 1);
              line-height: 21px;
              margin-bottom: 6px;
            }
            & > span {
              padding: 0px 15px;
              height: 52px;
              border: 1px solid rgba(221, 221, 221, 1);
              align-items: center;
              > input {
                height: 100%;
                font-size: 13px;
                font-family: SourceHanSerifCN-Medium, SourceHanSerifCN;
                font-weight: 500;
                color: rgba(48, 41, 41, 1);
                flex-grow: 1;
              }
              input::-webkit-input-placeholder {
                /* WebKit browsers */
                color: rgba(193, 190, 190, 1);
              }
              input:-moz-placeholder {
                /* Mozilla Firefox 4 to 18 */
                color: rgba(193, 190, 190, 1);
              }
              input::-moz-placeholder {
                /* Mozilla Firefox 19+ */
                color: rgba(193, 190, 190, 1);
              }
              input:-ms-input-placeholder {
                /* Internet Explorer 10+ */
                color: rgba(193, 190, 190, 1);
              }
              > em {
                height: 19px;
                font-size: 13px;
                font-family: SourceHanSerifCN-Medium, SourceHanSerifCN;
                font-weight: 500;
                color: rgba(230, 0, 18, 1);
                line-height: 19px;
                cursor: pointer;
              }
              .can-verify {
                color: rgba(193, 190, 190, 1);
              }
            }
            > em {
              height: 20px;
              > em {
                height: 17px;
                margin-left: 15px;
                font-size: 12px;
                font-family: SourceHanSerifCN-Medium, SourceHanSerifCN;
                font-weight: 500;
                color: rgba(230, 0, 18, 1);
                line-height: 17px;
                margin-bottom: 3px;
              }
            }
          }
          > h4 {
            width: 100%;
            justify-content: space-between;
            margin-bottom: 30px;
            > span {
              height: 21px;
              font-size: 15px;
              font-family: SourceHanSerifCN-SemiBold, SourceHanSerifCN;
              font-weight: 600;
              color: rgba(48, 41, 41, 1);
              line-height: 21px;
              cursor: pointer;
            }
          }
          > div {
            width: 100%;
            height: 52px;
            background: rgba(48, 41, 41, 1);
            > span {
              width: 100%;
              height: 100%;
              text-align: center;
              line-height: 52px;
              font-size: 15px;
              font-family: SourceHanSerifCN-SemiBold, SourceHanSerifCN;
              font-weight: 600;
              color: rgba(255, 255, 255, 1);
              cursor: pointer;
            }
          }
        }
        .login-footter {
          width: 100%;
          justify-content: space-between;
          align-items: center;
          .select-login-icon {
            align-items: center;
            > span {
              height: 19px;
              font-size: 13px;
              font-family: SourceHanSerifCN-Medium, SourceHanSerifCN;
              font-weight: 500;
              color: rgba(48, 41, 41, 1);
              line-height: 19px;
            }
            > ul {
              align-items: center;
              margin-left: 10px;
              width: 90px;
              justify-content: space-between;
              > li {
                width: 20px;
                height: 20px;
                cursor: pointer;
                > img {
                  width: 100%;
                  height: 100%;
                }
              }
            }
          }
          .agree-login {
            align-items: center;
            > span {
              width: 17px;
              height: 17px;
              background: url("../../assets/login/noselect_is_agree_icon.png")
                no-repeat center center;
              background-size: 17px 17px;
              cursor: pointer;
            }
            .select-active {
              width: 17px;
              height: 17px;
              background: url("../../assets/login/select_is_agree_icon.png")
                no-repeat center center;
              background-size: 17px 17px;
            }
            > strong {
              margin-left: 5px;
              height: 19px;
              font-size: 13px;
              font-family: SourceHanSerifCN-Medium, SourceHanSerifCN;
              font-weight: 500;
              color: rgba(48, 41, 41, 1);
              line-height: 19px;
              & > em {
                font-weight: bold;
                text-decoration: underline;
                cursor: pointer;
              }
              & > em:hover {
                color: #e60012;
              }
            }
          }
        }
      }
    }
  }
  .third-login {
    width: 553px;
    height: 553px;
  }
  .user-agreement {
    position: absolute;
    width: 473px;
    height: 473px;
    background: #fff;
    padding: 40px;
    & > em {
      flex-shrink: 0;
      width: 22px;
      height: 22px;
      background: url("../../assets/login/left_arrow_icon.png") no-repeat center
        center;
      background-size: 22px 22px;
      cursor: pointer;
    }
    & > div {
      width: 473px;
      height: 449px;
      flex-shrink: 0;
      & > span {
        font-size: 24px;
        font-family: SourceHanSerifCN-Medium, SourceHanSerifCN;
        font-weight: bold;
        color: rgba(48, 41, 41, 1);
        line-height: 32px;
        text-align: center;
        margin-bottom: 30px;
      }
      & > div {
        overflow-y: scroll;
        flex-grow: 1;
        font-size: 16px;
        font-family: SourceHanSerifCN-Medium, SourceHanSerifCN;
        font-weight: 400;
        color: rgba(48, 41, 41, 1);
        line-height: 24px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue